import { smb_fetch, getAgsApiUrl } from '@/api/operator/fetch';

/**
 * 接收内容
 */
export const getReceiveRecord = (data: any) => {
  const url = getAgsApiUrl('/v2/online-sales', 'lead/receive-record');
  return smb_fetch(url, {
    method: 'POST',
    data,
    contentType: 'application/json',
  }, true, false);
};
